import { css } from '@emotion/css';

const wrapper = css`
  width: 100%;
  margin: var(--dimensions-5) 0;
  border-radius: var(--radius-2));
`;

const button = css`
  &.MuiButtonBase-root {
    padding: var(--dimensions-2) var(--dimensions-1);
    align-items: center;
    text-align: left;
    text-transform: none;
    color: var(--colors-primary-950);
    height: auto;
  }
`;

const inputWrapper = css`
  padding: 0.75rem;
  border-width: 2px;
  border-style: dashed;
  border-radius: var(--radius-2);
  border-color: var(--colors-neutral-300);

  &:hover {
    border-style: solid;
    border-color: var(--colors-primary-500);
  }
`;

const errorInputWrapper = css`
  padding: 0.75rem;
  border-width: 2px;
  border-style: dashed;
  border-radius: var(--radius-2);
  border-color: var(--colors-error-900);
  &:hover {
    border-style: solid;
    border-color: var(--colors-error-900);
  }
`;

const inputButton = css`
  &.MuiButtonBase-root {
    width: 100%;
    justify-content: start;
    gap: var(--dimensions-2);
    color: var(--colors-primary-950);
    text-transform: none;
  }

  .textWrapper span {
    display: block;
    text-align: left;

    &:first-child {
      font-weight: 500;
      color: var(--colors-primary-900);
    }

    &:last-child {
      color: var(--colors-neutral-400);
    }
  }
`;

const documentsRow = css`
  &.MuiTypography-root {
    display: flex;
    padding: var(--spacings-1) var(--spacings-4);
    gap: 0.5rem;
    align-items: center;
    border-radius: var(--radius-2);
    text-decoration: none;
    color: var(--colors-primary-950);
    border-width: 1px;
    border-radius: var(--radius-2);
    border-color: var(--colors-neutral-300));
    transition: all 0.3s ease;
    margin-bottom: var(--spacings-2);
  }

  .MuiTypography-body2 {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .checkIcon {
    display: block;
    color: var(--colors-success-900);
    margin-left: auto;
  }
  .deleteButton {
    display: none;
    font-size: 100%;
    padding: 0;
    margin-left: auto;
  }
  &:hover {
    color: var(--colors-primary-500);
    .checkIcon {
      display: none;
      margin-left: auto;
    }
    .deleteButton {
      display: block;
      margin-left: auto;
    }
  }
`;

const errorMessage = css`
  color: var(--colors-error-900);
`;

const titleWrapper = css`
  display: flex;
  align-items: start;
  gap: var(--spacings-3);
`;

const singleFile = css`
  pointer-events: none;
  border-style: solid;
  border-color: var(--colors-warning-900);
  background-color: var(--colors-warning-500);
  display: none;
  .MuiButtonBase-root {
    color: var(--colors-neutral-500);
  }
  .textWrapper span {
    display: block;
    text-align: left;
    &:first-child {
      font-weight: 500;
      color: var(--colors-neutral-5090);
    }
    &:last-child {
      color: var(--colors-neutral-400);
    }
  }
`;

const FileInputStyles = {
  wrapper,
  button,
  inputWrapper,
  errorInputWrapper,
  inputButton,
  documentsRow,
  errorMessage,
  titleWrapper,
  singleFile,
};

export default FileInputStyles;
